var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('HomeKPI',{attrs:{"dashboard":_vm.dashboard}}),_c('v-row',[_c('v-col',{staticClass:"cols-md-12 cols-6"},[_c('ProjectList',{attrs:{"projects":_vm.dashboard.projects}})],1),_c('v-col',{staticClass:"cols-md-12 cols-6"},[_c('TaskToCome',{attrs:{"tasks":_vm.dashboard.tasks,"shortList":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }